export class TubeFLModel {
  _id?: string | undefined;
  factory_number?: string = "";
  serial_number?: string = "";
  type?: string = "";
  dp?: string = "";
  lg?: string = "";
  color?: string = "";
  fitting_right?: string = "";
  fitting_left?: string = "";
  measure_right?: string = "";
  measure_left?: string = "";
  material_right?: string = "";
  material_left?: string = "";
  area?: string = "";
  substance?: string = "";
  client_code?: string = "";
  client_name?: string = "";
}
